module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0070.jpg?v=b0953540";